module.exports = __webpack_public_path__ + "static/media/3f-logo.067d5d8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Logos/3f-logo.svg
// module id = 400
// module chunks = 0